/** @format */
// import "./index.scss";
export default function Button({ action, title, customStyle }) {
  return (
    <button
      className={`button-style button-style--${customStyle}`}
      onClick={action}
    >
      {title}
    </button>
  );
}
